// extracted by mini-css-extract-plugin
module.exports = {"textFlex":"footer-module--text-flex--2Awea","authorName":"footer-module--author-name--1O1VT","credits":"footer-module--credits--3O-vO"};